/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconDrag16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDrag16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M10.166 4.996A1.499 1.499 0 1 0 10.167 2a1.499 1.499 0 0 0-.001 2.997ZM5.832 4.996a1.499 1.499 0 1 0 0-2.997 1.499 1.499 0 0 0 0 2.997ZM7.331 8A1.499 1.499 0 1 1 4.333 8 1.499 1.499 0 0 1 7.331 8ZM10.163 9.498a1.499 1.499 0 1 0 .002-2.997 1.499 1.499 0 0 0-.002 2.997ZM7.331 12.502a1.499 1.499 0 1 1-2.998-.001 1.499 1.499 0 0 1 2.998 0ZM10.166 14a1.499 1.499 0 1 0 .001-2.998A1.499 1.499 0 0 0 10.166 14Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconDrag20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDrag20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M12.71 6.245a1.873 1.873 0 1 0 .002-3.747 1.873 1.873 0 0 0-.002 3.747ZM7.292 6.245a1.873 1.873 0 1 0 .002-3.747 1.873 1.873 0 0 0-.002 3.747ZM9.167 10a1.873 1.873 0 1 1-3.747-.002A1.873 1.873 0 0 1 9.167 10ZM12.707 11.873a1.874 1.874 0 1 0 .002-3.747 1.874 1.874 0 0 0-.002 3.747ZM9.167 15.627a1.873 1.873 0 1 1-3.747-.001 1.873 1.873 0 0 1 3.747.001ZM12.71 17.5a1.873 1.873 0 1 0 .002-3.747 1.873 1.873 0 0 0-.002 3.747Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconDrag24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDrag24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M15.25 7.494a2.248 2.248 0 1 0-2.248-2.247 2.248 2.248 0 0 0 2.249 2.247ZM8.75 7.494A2.248 2.248 0 1 0 6.5 5.247a2.248 2.248 0 0 0 2.25 2.247ZM10.998 12a2.248 2.248 0 0 1-2.249 2.247A2.248 2.248 0 1 1 11 12ZM15.247 14.247A2.248 2.248 0 1 0 12.997 12a2.248 2.248 0 0 0 2.25 2.247ZM10.998 18.753A2.248 2.248 0 0 1 8.75 21 2.248 2.248 0 1 1 11 18.753ZM15.25 21a2.248 2.248 0 1 0-2.248-2.247A2.248 2.248 0 0 0 15.25 21Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconDrag = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDrag(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconDrag16 {...iconProps} />;
        case '20':
            return <IconDrag20 {...iconProps} />;
        case '24':
            return <IconDrag24 {...iconProps} />;
        default:
            return <IconDrag24 {...iconProps} />;
    }
});
